/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressSchema } from './AddressSchema';
import {
    AddressSchemaFromJSON,
    AddressSchemaFromJSONTyped,
    AddressSchemaToJSON,
} from './AddressSchema';

/**
 * 
 * @export
 * @interface BillingContactSchema
 */
export interface BillingContactSchema {
    /**
     * 
     * @type {string}
     * @memberof BillingContactSchema
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactSchema
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactSchema
     */
    phone?: string;
    /**
     * 
     * @type {AddressSchema}
     * @memberof BillingContactSchema
     */
    address?: AddressSchema;
}

/**
 * Check if a given object implements the BillingContactSchema interface.
 */
export function instanceOfBillingContactSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BillingContactSchemaFromJSON(json: any): BillingContactSchema {
    return BillingContactSchemaFromJSONTyped(json, false);
}

export function BillingContactSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingContactSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'address': !exists(json, 'address') ? undefined : AddressSchemaFromJSON(json['address']),
    };
}

export function BillingContactSchemaToJSON(value?: BillingContactSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'address': AddressSchemaToJSON(value.address),
    };
}

